import styled from "@emotion/styled";
import Icon from "./icon";
import { Colors } from "theme/colors";

export const StyledCopy = styled(Icon)`
  display: inline-block;
  margin-left: 0.5rem;
  cursor: pointer;

  color: ${Colors.PURPLE};

  &:hover {
    color: ${Colors.LIGHT_PURPLE};
  }
`;
